module.exports = __webpack_public_path__ + "img/logo_admin.96e8b81f.svg";